import { render, staticRenderFns } from "./BaseServer.vue?vue&type=template&id=130fd7c1&"
import script from "./BaseServer.vue?vue&type=script&lang=js&"
export * from "./BaseServer.vue?vue&type=script&lang=js&"
import style0 from "./BaseServer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports